import { inject, Injectable, NgZone } from '@angular/core';
import { MercadoPagoSettings, PaymentProcess } from '../interfaces/interfaces';
import { environment } from '../../environments/environment';
import { OtpService } from './otp.service';
import { Router } from '@angular/router';

interface WindowWithCardPaymentBrickController extends Window {
  MercadoPago: any;
  cardPaymentBrickController: any;
}

declare const window: WindowWithCardPaymentBrickController;
@Injectable({
  providedIn: 'root'
})
export class MercadoPagoService {
  publicToken!: string;
  isPayment!: boolean;
  ngZone = inject(NgZone);
  otpService = inject(OtpService);
  router = inject(Router);
  settings: MercadoPagoSettings = {
    initialization: {
      amount: 20, // Se setea en función del pais desde process-checkout
      payer: {
        email: "",
      },
    },
    customization: {
      texts: { //Se setea una vez renderizado por problemas con el SDK
        formSubmit: "Registrar"
      },
      visual: {
        style: {
          theme: "default", // | 'dark' | 'bootstrap' | 'flat'
          customVariables: {
            formBackgroundColor: "#eaeaea",
            buttonTextColor: "black",
            baseColor: "#ffd102",
            
          },
        },
      },
      paymentMethods: {
        maxInstallments: 1,
      },
    },
    callbacks: {
      onReady: () => {
        // No he conseguido cambiar los textos mediante los settings
        let submitButton = document.querySelector("#cardPaymentBrick_container button[type='submit']");
        if(submitButton){
          submitButton.textContent = "Registrar";
          if(this.isPayment) {
            submitButton.textContent = "Pagar";
          }
        }
      },
      onSubmit: (cardFormData: any, additionalData: any) => {
        return new Promise<void>((resolve, reject) => {
          fetch(`${environment.baseUrl}${environment.endpoints.TOKENIZATION.processPayment}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": this.otpService.getInitialConfig().token || localStorage.getItem("token") as string
            },
            body: JSON.stringify(this.mapCardFormData(cardFormData, additionalData)),
          })
            .then((response) => {
              this.otpService.resetTokenizationProps();
              if(!response.ok) {
                return this.ngZone.run(() => {
                  return this.router.navigate(["process-error"])
                })
              }
              return this.router.navigate(["process-success"]);
            })
            .catch((error) => {
              console.error(error);
              reject();
            });
        });
      },
      onError: (error: any) => {},
    },
  };

  getSettings(): MercadoPagoSettings {
    return this.settings;
  }

  setIsPayment(isPayment: boolean) {
    this.isPayment = isPayment;
  }

  setMercadopagoToken(country: string) {
    switch (country) {
      case 'AR':
        this.publicToken = environment.tokenMp.AR;
        break;
      case 'UY':
        this.publicToken = environment.tokenMp.UY;
        break;
      case 'CL':
        this.publicToken = environment.tokenMp.CL;
        break;
      case 'CO':
        this.publicToken = environment.tokenMp.CO;
        break;
      case 'PE':
        this.publicToken = environment.tokenMp.PE;
        break;
    }
  }

  setInitializationAmount(country: string) {
    switch (country) {
      case 'AR':
        this.settings.initialization.amount = 5;
        break;
      case 'UY':
        this.settings.initialization.amount = 15;
        break;
      case 'CL':
        this.settings.initialization.amount = 1000;
        break;
      case 'CO':
        this.settings.initialization.amount = 1000;
        break;
      case 'PE':
        this.settings.initialization.amount = 1;
        break;
    }
  }

  mapCardFormData(data: any, additionalData: any): PaymentProcess {
    const { payment_method_id, issuer_id, payer, token } = data;
    const { email, identification } = payer;
    const { type, number } = identification;
    const { cardholderName } = additionalData;

    return {
      cardHolder: {
          name: cardholderName,
          documentType: type,
          documentNumber: number,
          email: email,
      },
      tokenSdk: token,
      paymentMethodId: payment_method_id,
      issuerId: issuer_id,
    }
  }

  launchMercadoPago() {
    const mp = new window.MercadoPago(this.publicToken, { locale: `es-${this.otpService.getLocale()}` });
    const bricksBuilder = mp.bricks();
    this.renderCardPaymentBrick(bricksBuilder, this.getSettings());
  }

  async renderCardPaymentBrick(bricksBuilder: any, settings: MercadoPagoSettings) {
    window.cardPaymentBrickController = await bricksBuilder.create(
      "cardPayment",
      "cardPaymentBrick_container",
      settings
    );
  }
}
